import { fetchFollowersByChannel } from './fetch-followers-by-channel.action';
import { fetchFanbaseEvolution } from './fetch-fanbase-evolution.action';
import { fetchFanbaseEvolutionTable } from './fetch-fanbase-evolution-table.action';

import { fetchTotalPublications } from './fetch-total-publications.action';
import { fetchPublicationsByMediaType } from './fetch-publications-by-media-type.action';
import { fetchTopPublications } from './fetch-top-publications.action';
import { fetchPublicationsOverTimeWithDistribution } from './fetch-publications-over-time-with-distribution.action';

import { fetchInteractionsOverTime } from './fetch-interactions-over-time.action';
import { fetchInteractionsAndEngagementRate } from './fetch-interactions-and-engagement-rate.action';
import { fetchInteractionsByMediaType } from './fetch-interactions-by-media-type.action';
import { fetchInteractionsBySocialNetwork } from './fetch-interactions-by-social-network.action';
import { fetchAverageInteractionsByPublication } from './fetch-average-interactions-by-publication.action';
import { fetchEngagementOverTime } from './fetch-engagement-over-time.action';
import { fetchEngagementMatrix } from './fetch-engagement-matrix.action';
import { fetchDistributionOfInteractions } from './fetch-distribution-of-interactions';
import { fetchTermsMentioned } from './fetch-terms-mentioned.action';
import { fetchSentimentsInTheComments } from './fetch-sentiments-in-the-comments.action';
import { fetchSentimentsInTheCommentsOverTime } from './fetch-sentiments-in-the-comments-over-time.action';

import { addFanbaseEvolutionPeriod } from './add-fanbase-evolution-period.action';
import { addInteractionsOverTimePeriod } from './add-interactions-over-time-period.action';
import { addEngagementOverTimePeriod } from './add-engagement-over-time-period.action';
import { addSentimentsInTheCommentsOverTimePeriod } from './add-sentiments-in-the-comments-over-time-period.action';
import { addSentimentsInTheCommentsOverTimeGroup } from './add-sentiments-in-the-comments-over-time-group.action';
import { addPublicationsOverTimeWithDistributionPeriod } from './add-publications-over-time-with-distribution-period.action';
import { addPublicationsOverTimeWithDistributionGroup } from './add-publications-over-time-with-distribution-group.action';

export const actions = {
  fetchFollowersByChannel,
  fetchFanbaseEvolution,
  fetchFanbaseEvolutionTable,

  fetchTotalPublications,
  fetchPublicationsByMediaType,
  fetchTopPublications,
  fetchPublicationsOverTimeWithDistribution,

  fetchInteractionsOverTime,
  fetchInteractionsAndEngagementRate,
  fetchInteractionsByMediaType,
  fetchInteractionsBySocialNetwork,
  fetchAverageInteractionsByPublication,
  fetchEngagementOverTime,
  fetchEngagementMatrix,
  fetchDistributionOfInteractions,
  fetchTermsMentioned,
  fetchSentimentsInTheComments,
  fetchSentimentsInTheCommentsOverTime,

  addFanbaseEvolutionPeriod,
  addInteractionsOverTimePeriod,
  addEngagementOverTimePeriod,
  addSentimentsInTheCommentsOverTimePeriod,
  addSentimentsInTheCommentsOverTimeGroup,
  addPublicationsOverTimeWithDistributionPeriod,
  addPublicationsOverTimeWithDistributionGroup,
};
